import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const CloudServices = () => {
  return (
    <PageTemplate title="Cloud Services" subtitle="Comprehensive cloud solutions for modern businesses" breadcrumb="Services > Cloud Services">
      <div className="content-section">
        <h3>Cloud Migration & Consulting</h3>
        <p>Cloud consulting, migration services, and SaaS development solutions.</p>
      </div>
    </PageTemplate>
  );
};

export default CloudServices; 